//****************************************************************************
//
// Copyright(C) 2025, CyberTAN Technology, Inc. All Rights Reserved.
// This source code contains confidential and proprietary
// information of CyberTAN Technology, Inc. Unauthorized reproduction,
// modification, distribution, or disclosure of this file, in whole or in part,
// by any means, is strictly prohibited without prior written permission from
// CyberTAN Technology, Inc.
//
// THIS SOURCE CODE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
// EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND NONINFRINGEMENT.
//
// IN NO EVENT SHALL CYBERTAN TECHNOLOGY, INC. BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
// TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOURCE CODE.
//
//****************************************************************************

import { usePortalAuth } from 'contexts/AuthPortalProvider';
import { useAuth } from 'contexts/AuthProvider';
import { useConfig } from 'contexts/ConfigProvider';
import Loading from 'pages/Loading';
import { lazy } from 'react';
import { BuildVersionList } from 'utils/helper';

/* portal */
const PortalLogin = lazy(() => import('pages/PortalLogin'));

/* contoller */
const Login = lazy(() => import('pages/Login'));

const RequirePortalAuth = ({ children }: { children: JSX.Element }) => {
  const { token } = usePortalAuth();

  if (!token) {
    return <PortalLogin />;
  }

  return children;
};

const RequireControllerAuth = ({ children }: { children: JSX.Element }) => {
  const { token } = useAuth();

  if (!token) {
    return <Login />;
  }

  return children;
};

const RequireAuth = ({ children }: { children: JSX.Element }) => {
  const { buildVersion } = useConfig();

  return buildVersion ? (
    buildVersion === BuildVersionList.portal ? (
      <RequirePortalAuth>{children}</RequirePortalAuth>
    ) : (
      <RequireControllerAuth>{children}</RequireControllerAuth>
    )
  ) : (
    <Loading />
  );
};

export default RequireAuth;
